export const SharedHtmlPath: string = '../../../../../assets/shared/';
